// V1-COMPAT: the name react18_component/react18_mount.js mount as "V1SourceDirectory" --
// the copied V2 SourceDirectory (source_directory/SourceDirectory.jsx) wrapped with the V2
// identity glue (see with_v2_identity.jsx) so its saved-groups and last-messages features work
// for a signed-in V1 viewer the same way they do when V2 hosts itself.
import withV2Identity from './with_v2_identity';
import SourceDirectory from '../source_directory/SourceDirectory';

const V1SourceDirectory = withV2Identity(SourceDirectory);

export default V1SourceDirectory;
